<soft-entity-input
  [readonly]="readonly"
  [placeholder]="placeholder"
  [value]="value"
  [title]="title"
  (valueChange)="setValue($event)"
  [strategy]="strategy"
  [parameters]="{current: value, parameters: parameters}"
  [ngClass]="customClass"
  #input
  >
  <ng-template let-entity="entity" #entityTemplate>
    <ng-container
      *ngTemplateOutlet="
        template || defaultTemplate;
        context: { entity: entity }
      "
    ></ng-container>
  </ng-template>
</soft-entity-input>
<ng-template let-entity="entity" #defaultTemplate>
  @if (config?.template && (config?.template | typeof) !== 'string') {
    <ng-container *ngComponentOutlet="$any(config?.template); inputs: {item: entity}"></ng-container>
  } @else {
    @if (config?.template) {
      {{ $any(config?.template) | interpolate:entity}}
    } @else {
      {{ entity | json }}
    }
  }
</ng-template>
